/*
    Merrid Controls. Wszelkie prawa zastrzeżone.
    Plik zawiera kody Źródłowe będące własnością firmy Merrid Controls.
    Nie wolno ich rozpowszechniać w całości lub fragmentach bez wyraźnej zgody właściciela.
*/


import React, {useContext, useEffect, useRef, useState} from "react";

import {useDispatch} from "react-redux";
import {useTypedSelector} from "@Services/Hooks/UseTypedSelector";
import CHANGE_API_REQUEST_STATUS_ACTION from "@Actions/Interface/ChangeApiRequestStatus";

import ApplicationApiContext from "@Contexts/Api";

import APPLICATION_ROUTER_INTERFACE from "@ROUTER/Interfaces/Router";
import ApplicationRouterContext from "@Contexts/Router";

import LOGGED_USER_INTERFACE from "@Store/Interfaces/Authentication/User";

import USER_INTERFACE, {BHP_INTERFACE} from "@Services/Application/Interfaces/Users/User";

import {HTTP_ERROR_RESPONSE_INTERFACE} from "@Services/Interfaces/Http/Response/Error";
import {ERROR_SYSTEM_MESSAGE_INTERFACE} from "@Services/Application/Interfaces/_Messages/Errors";

import DEFAULT_REQUEST_HEADERS from "@Services/Interfaces/Http/Request/Headers";


import dateFormat from "dateformat";


import {Redirect} from "react-router-dom";


import {Col, Row} from "react-bootstrap";


import ErrorMessageComponent from "@Components/UI/Communicates/Messages/Error";


import BlockContentHeaderComponent from "@Components/UI/Containers/Block/Header";
import BlockContentContainerComponent from "@Components/UI/Containers/Block";


import SettingsSMSCodeVerificationComponent from "@UIPages/Authenticated/Settings/_Parts/Verification";
import REST_API_REQUEST from "@Services/Utilities/Requests";
import AUTHORIZATION_TOKEN_INTERFACE from "@Reducers/Api/RequestToken";
import ContentInformationComponent from "@Components/UI/Content/Information";
import BhpCourseComponent from "./BhpCourse";
import BhpQuizDisplaySwitcherComponent from "./Switcher";





type BhpCoursesPageProps = {};


export const BhpCoursesPageComponent: React.FC<BhpCoursesPageProps> = (): JSX.Element | null => {


    /** @const Global State Actions Dispatcher */
    const DISPATCHER = useDispatch();


    /** @const {React.Ref} My Favourite Terminals Page Container DOM Ref */
    const COMPONENT_REF: React.Ref<HTMLDivElement | null> = useRef(null);


    /** @const {UserInterface | null} Application Logged User (from Global Store Object) */
    const LOGGED_USER: LOGGED_USER_INTERFACE = useTypedSelector(
        (state): ReturnType<any> => state?.authentication
    )?.loggedUser || null;


    /** @const {string} Global Rest Api Root URL Address */
    const REST_API_URL = useContext(ApplicationApiContext)?.API_ROOT_URL || null;

    /** @const {object} REST_API_DATA - Application State Store Rest Api Data */
    const REST_API_DATA:ReturnType<any> = useTypedSelector(
        (state) => state.api
    );

    /** @const {} REST_API_REQUEST_TOKEN - Application Rest Api Request Token */
    const REST_API_REQUEST_TOKEN: AUTHORIZATION_TOKEN_INTERFACE = REST_API_DATA?.requestToken || null;


    const ROUTER: APPLICATION_ROUTER_INTERFACE = useContext(ApplicationRouterContext);


    const [userVerifiedStatus, setUserVerifiedStatus] = useState<boolean>(false);

    const changeUserVerifiedStatus = (response: any) => {
        if (response.OperationGUID) setUserVerifiedStatus(true);
    };

    /** @var {[object, function]} State - User Profile Data Object, User Profile Data Object Setter */
    const [USER_MY_BHP_DATA, SET_USER_MY_BHP_DATA] = useState<USER_INTERFACE | null>(null);
    /** @var {[boolean, function]} State - User Profile Component Error, User Profile Component Error Setter */
    const [USER_MY_BHP_ERROR, SET_USER_MY_BHP_ERROR] = useState<ERROR_SYSTEM_MESSAGE_INTERFACE | null>(null);

    const [SHOW_ALL_BHP_QUZIZES_STATUS, SET_SHOW_ALL_BHP_QUZIZES_STATUS] = useState<boolean>(false);

    /** @hook {didMount, didUpdate} Get Terminals List from REST API */
    useEffect(() => {

        if (!userVerifiedStatus) return;

        /* Check if Monitory Note ID, API URL Present, User Logged */
        if (!REST_API_URL || !LOGGED_USER?.userID) return; // No Valid Data - Stop

        /** @const USER_MY_BHP_API_URL User Profile REST API Endpoint URL */
        const USER_MY_BHP_API_URL: string = REST_API_URL + "/User/Get";

        /** @const USER_MY_BHP_REQUEST_DATA User Profile Request Data Object */
        const USER_MY_BHP_REQUEST_DATA = {
            UserId: LOGGED_USER?.userID, // Logged User ID
            ContentType: "B" // Data Return Mode - Main User Data
        };

        /** @async {function} User Profile Data Request Handler */
        const GET_USER_MY_BHP_DATA = async (): Promise<void | Function> => {
            /* Change Global Rest Api Request Status Action */
            DISPATCHER(CHANGE_API_REQUEST_STATUS_ACTION(true)); // Set Status to true

            try {

                const USER_DATA_RESPONSE = await REST_API_REQUEST(
                    USER_MY_BHP_API_URL,
                    USER_MY_BHP_REQUEST_DATA,
                    REST_API_REQUEST_TOKEN
                );

                if (USER_DATA_RESPONSE.status === 200) {
                    const CONTENT = await USER_DATA_RESPONSE.text();
                    if (CONTENT.trim()) {
                        SET_USER_MY_BHP_DATA(JSON.parse(CONTENT));
                    }
                } else {
                    if (USER_DATA_RESPONSE.status === 409) {
                        const CONTENT: HTTP_ERROR_RESPONSE_INTERFACE = await USER_DATA_RESPONSE.json();
                        SET_USER_MY_BHP_ERROR({ErrorCode: CONTENT.ErrorCode, UserMessage: CONTENT.UserMessage});
                    } else {
                        SET_USER_MY_BHP_ERROR({ErrorCode: USER_DATA_RESPONSE.status, UserMessage: "Wystąpił nieokreślony błąd - skontaktuj się z CDOK"});
                    }
                }

            } catch (e) {
                SET_USER_MY_BHP_ERROR({ErrorCode: 500, UserMessage: "Wystąpił nieokreślony błąd - skontaktuj się z CDOK"});
            }

            /* Change Global Rest Api Request Status Action */
            DISPATCHER(CHANGE_API_REQUEST_STATUS_ACTION(false));

        };

        GET_USER_MY_BHP_DATA();

    }, [userVerifiedStatus]);


    useEffect(() => {
        return () => {SET_USER_MY_BHP_ERROR(null);};
    }, []);


    if (!LOGGED_USER || !LOGGED_USER?.userID) return <Redirect to={ROUTER.NOT_AUTHENTICATED.LOGIN.URL}/>;


    if (!ROUTER) return <Redirect to={"/404"}/>;


    if (!userVerifiedStatus) return <SettingsSMSCodeVerificationComponent verificationStatusHandler={changeUserVerifiedStatus} />;


    const {DriverBHPs: userBHP} = USER_MY_BHP_DATA || {};
    
    const UserBHPFavorites = !userBHP ? null : userBHP.map((bhp: BHP_INTERFACE, i: number) => {

        const {Favorite: documentFavorite} = bhp;

        return (
            (!!documentFavorite) && <BhpCourseComponent BHP_COURSE={bhp}/>            
        )
    });

    const UserBHPOthers = !userBHP ? null : userBHP.map((bhp: BHP_INTERFACE, i: number) => {

        const {Favorite: documentFavorite} = bhp;

        return (
            (!documentFavorite) && <BhpCourseComponent BHP_COURSE={bhp}/>            
        )

    });

    return (
        <BlockContentContainerComponent forwardRef={COMPONENT_REF} cssClasses={"settings-page-user-data-component settings-page-view-component"}>

            <BlockContentHeaderComponent headerText={"Moje Szkolenia BHP"} />

            <Col xs={12} className={"user-profile-data user-information-data"}>
                <Row className={"user-profile-data-content"}>

                    {!!USER_MY_BHP_ERROR && <ErrorMessageComponent messageText={USER_MY_BHP_ERROR.UserMessage} />}

                    {((!!UserBHPFavorites && UserBHPFavorites?.length > 0) || (!!UserBHPOthers && UserBHPOthers?.length > 0))  ?                       
                            
                        <Col xs={12} className={"content-items-list"}>
                            <Col xs={12} className={"terminals-list-header content-items-list-header"}>
                                <span>Ulubione terminale</span>
                            </Col>
                            {UserBHPFavorites}
                            {UserBHPOthers?.length &&
                                <BhpQuizDisplaySwitcherComponent
                                    SHOW_ALL_BHP_QUZIZES_STATUS={SHOW_ALL_BHP_QUZIZES_STATUS || !UserBHPOthers?.length}
                                    SHOW_ALL_BHP_QUZIZES_STATUS_HANDLER={SET_SHOW_ALL_BHP_QUZIZES_STATUS}
                                />    
                            }                                                     
                            {SHOW_ALL_BHP_QUZIZES_STATUS && 
                                <>
                                    <Col xs={12} className={"terminals-list-header content-items-list-header"} style={{marginTop:"20px"}}>
                                        <span>Pozostałe terminale</span>
                                    </Col>
                                    {UserBHPOthers}                            
                                </> 
                            }
                        </Col>
                                               
                        :

                        !USER_MY_BHP_ERROR && <ContentInformationComponent contentMessage={`Brak Szkoleń BHP`} />
                    }

                </Row>
            </Col>

        </BlockContentContainerComponent>
    );

}


export default BhpCoursesPageComponent;
